__turbopack_context__.v({
  "char": "FloatingStatement-module__ugmyvq__char",
  "char-in": "FloatingStatement-module__ugmyvq__char-in",
  "hasWatermark": "FloatingStatement-module__ugmyvq__hasWatermark",
  "inner": "FloatingStatement-module__ugmyvq__inner",
  "last": "FloatingStatement-module__ugmyvq__last",
  "prefix": "FloatingStatement-module__ugmyvq__prefix",
  "section": "FloatingStatement-module__ugmyvq__section",
  "statement": "FloatingStatement-module__ugmyvq__statement",
  "suffix": "FloatingStatement-module__ugmyvq__suffix",
  "watermark": "FloatingStatement-module__ugmyvq__watermark",
  "word": "FloatingStatement-module__ugmyvq__word",
});
